import NotificationTemplateTypes from 'store/actionTypes/notificationTemplate'
import NotificationTemplateTechTypes from 'store/actionTypes/notificationTemplateTech'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  systems: [],
  pagination: {},
  filter: {},
  platformTechs: [],
  platformPageTechs: []
}

const notificationTemplate = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case NotificationTemplateTypes.GET_GROUPS_SUCCESS:
      return {
        ...state,
        groups: payload?.items
      }
    case NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATE_DETAIL_SUCCESS:
      return { ...state, current: payload }

    case NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATE_DETAIL_FAILED:
      return { ...state, current: {} }
    case NotificationTemplateTypes.UPDATE_FILTER_NOTIFICATION_TEMPLATE_SUCCESS:
      return { ...state, filter: payload }
    case NotificationTemplateTechTypes.GET_NOTIFICATION_TEMPLATE_TECH_BY_NOTIFICATION_TEMPLATE_ID_SUCCESS:
      return { ...state, platformTechs: payload?.items }
    case NotificationTemplateTypes.GET_PLATFORM_PAGE_TECH_IN_NOTIFICATION_TEMPLATE_SUCCESS:
      return { ...state, platformPageTechs: payload?.items }
    case NotificationTemplateTypes.GET_PLATFORM_PAGE_TECH_IN_NOTIFICATION_TEMPLATE_FAILED:
      return { ...state, platformPageTechs: [] }
    case NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATES_SUCCESS:
      return { ...state, systems: payload?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default notificationTemplate
